module.exports = __webpack_public_path__ + "img/icon-used.bbbccd15.png";